// extracted by mini-css-extract-plugin
module.exports = {"text":"RequestIdAndCreationDate_text__1ziIA","rate":"RequestIdAndCreationDate_rate__A3cxw"};